import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [variant, setVariant] = useState('default');

  useEffect(() => {
    const mouseMove = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    const mouseEnterHandler = (e) => {
      if (e.target.tagName === 'A' || e.target.tagName === 'BUTTON' || e.target.closest('a, button')) {
        setVariant('hover');
      }
    };

    const mouseLeaveHandler = (e) => {
      if (e.target.tagName === 'A' || e.target.tagName === 'BUTTON' || e.target.closest('a, button')) {
        setVariant('default');
      }
    };

    window.addEventListener('mousemove', mouseMove);
    document.addEventListener('mouseover', mouseEnterHandler);
    document.addEventListener('mouseout', mouseLeaveHandler);

    return () => {
      window.removeEventListener('mousemove', mouseMove);
      document.removeEventListener('mouseover', mouseEnterHandler);
      document.removeEventListener('mouseout', mouseLeaveHandler);
    };
  }, []);

  const variants = {
    default: {
      height: 32,
      width: 32,
      backgroundColor: 'rgba(67, 97, 238, 0.1)', // Faint accent color
      border: '2px solid #4361EE', // Accent color
      mixBlendMode: 'normal',
    },
    hover: {
      height: 64,
      width: 64,
      backgroundColor: '#F5F5F7', // Text primary color
      mixBlendMode: 'difference',
    },
  };

  return (
    <>
      {/* The trailing outline circle */}
      <motion.div
        className="fixed top-0 left-0 rounded-full pointer-events-none z-[9999]"
        style={{
          x: position.x - 16, // Center the 32x32 circle
          y: position.y - 16,
        }}
        variants={variants}
        animate={variant}
        transition={{ type: 'spring', stiffness: 400, damping: 30 }}
      />
      {/* The small central dot */}
      <motion.div
        className="fixed top-0 left-0 w-2 h-2 rounded-full bg-text-primary pointer-events-none z-[9999]"
        style={{
          x: position.x - 4, // Center the 8x8 dot
          y: position.y - 4,
        }}
        transition={{ type: 'spring', stiffness: 800, damping: 40 }}
      />
    </>
  );
};

export default CustomCursor;